import * as React from 'react'

interface RechargeCartePrepayeeIconProps extends React.SVGProps<SVGSVGElement> {
  strokeColor?: string
}

const RechargeCartePrepayeeIcon: React.FC<RechargeCartePrepayeeIconProps> = ({ strokeColor }) => {
  return (
<svg width="25" height="25" viewBox="0 0 25 25" 
className={strokeColor}
fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.3333 10.2085C21.2999 8.1439 21.1401 6.95118 20.3767 6.09532C20.2222 5.92219 20.052 5.76207 19.868 5.61679C18.7173 4.7085 16.9937 4.7085 13.5468 4.7085H10.7954C7.3484 4.7085 5.62489 4.7085 4.47421 5.61679C4.29017 5.76207 4.11996 5.92219 3.96553 6.09532C3 7.17779 3 8.79914 3 12.0418C3 15.2845 3 16.9058 3.96553 17.9883C4.11996 18.1615 4.29017 18.3215 4.47421 18.4668C5.62489 19.3752 7.3484 19.3752 10.7954 19.3752H11.25"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M3 9.2915H21.3333"  strokeWidth="2" strokeLinejoin="round"/>
<path d="M18.8889 12.9585L19.6435 13.6532C19.8077 13.8147 19.8899 13.8954 19.861 13.964C19.832 14.0326 19.7159 14.0326 19.4836 14.0326H16.6379C15.181 14.0326 14 15.1933 14 16.6252C14 16.9479 14.06 17.2568 14.1696 17.5418M16.4445 20.2918L15.6899 19.5971C15.5256 19.4357 15.4435 19.3549 15.4724 19.2863C15.5013 19.2178 15.6175 19.2178 15.8497 19.2178H18.6954C20.1523 19.2178 21.3333 18.057 21.3333 16.6252C21.3333 16.3024 21.2733 15.9935 21.1638 15.7085"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

  )
}

export default RechargeCartePrepayeeIcon
